import { useReportStore } from '@/entities/report';

/**
 * Exposes the PDF download progress figures for the report loading overlay. Selects progressDownload and estimateDownload from the report store.
 *
 * @returns An object carrying progressDownload and estimateDownload.
 */
const usePDFLoading = () => {
  const progressDownload = useReportStore((s) => s.progressDownload);
  const estimateDownload = useReportStore((s) => s.estimateDownload);

  return { progressDownload, estimateDownload };
};

export default usePDFLoading;
